import { useState } from 'react';
import { useMutation } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { InvestmentPaths } from '../../investments.types';

const MONEY_TRANSFER_ERROR = 'has unpaid money transfers';

interface Orders {
  instrumentId: number;
  percentage?: number;
}

export interface SwitchModelPayload {
  newInvestmentType?: string;
  preOrders: Orders[];
  investmentAmount?: number;
}
const useSwitchInvestmentModelQuery = (id: string, onSuccess?: () => void, onError?: () => void) => {
  const [isMoneyTransferError, setMoneyTransferError] = useState(false);
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (payload: SwitchModelPayload) =>
      api.patch(API_URL.INVESTORS_INVESTMENT_MODELS, {
        new_investment_type: payload.newInvestmentType || InvestmentPaths.SELF_DIRECTED,
        pre_orders: payload.preOrders.map((item) => ({
          instrument_id: item.instrumentId,
          percentage: item.percentage,
        })),
        investment_amount: payload.investmentAmount || null,
      }),
    {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
      onError: (error) => {
        const message = _.get(error, 'response.data.elevate_error_message', '') as string;

        if (message.includes(MONEY_TRANSFER_ERROR)) {
          setMoneyTransferError(true);
        } else if (onError) {
          onError();
        }
      },
    }
  );

  return {
    isMoneyTransferError,
    setMoneyTransferError,
    handleSave: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
};
export default useSwitchInvestmentModelQuery;
